<script setup lang="ts">
import { Head, Link } from '@inertiajs/vue3'
import PageHeading from '@/Components/Headings/PageHeading.vue'
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'
import Table from '@/Components/Table/Table.vue'
import Button from '@/Components/Utils/Button.vue'
import ModalConfirmationDelete from '@/Components/Utils/ModalConfirmationDelete.vue'
import { useFormatCurrency } from '@/Composables/useFormatCurrency'
import { useFormatTime } from '@/Composables/useFormatTime'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCheckCircle, faTimesCircle } from '@fas'
import { faHourglassHalf } from '@fal'
import { library } from '@fortawesome/fontawesome-svg-core'
library.add(faCheckCircle, faTimesCircle, faHourglassHalf)

defineProps<{
    pageHead?: PageHeadingTS
    title?: string
    data: {}
}>()
</script>

<template>
    <Head :title="title" />
    <PageHeading :data="pageHead" />
    <Table :resource="data">
        <template #cell(name)="{ item }">
            <Link :href="route('custom-size.offers.show', item.id)" class="primaryLink">
                {{ item.name }}
            </Link>
        </template>

        <template #cell(box_size)="{ item }">
            <span :class="item.box_size ? '' : 'italic text-gray-400'">{{ item.box_size || '-' }}</span>
        </template>

        <template #cell(plano_name)="{ item }">
            <span :class="item.plano_name ? '' : 'italic text-gray-400'">{{ item.plano_name || '-' }}</span>
        </template>

        <template #cell(frames_per_plano)="{ item }">
            {{ item.frames_per_plano ?? '-' }}
        </template>

        <template #cell(selling_price)="{ item }">
            {{ item.selling_price === null ? '-' : useFormatCurrency(item.selling_price) }}
        </template>

        <template #cell(status)="{ item }">
            <div class="flex items-center gap-x-1.5">
                <FontAwesomeIcon :icon="item.status_icon.icon" :class="item.status_icon.class" fixed-width
                    aria-hidden="true" />
                {{ item.status_label }}
            </div>
            <div v-if="item.deal_date" class="pl-6 text-xs text-gray-500">{{ useFormatTime(item.deal_date) }}</div>
            <div v-if="item.production_plan_label" class="pl-6 text-xs text-gray-500">
                Produksi: {{ item.production_plan_label }}
            </div>
        </template>

        <template #cell(updated_at)="{ item }">
            {{ useFormatTime(item.updated_at) }}
        </template>

        <template #cell(actions)="{ item }">
            <ModalConfirmationDelete
                :routeDelete="{ name: 'custom-size.offers.delete', parameters: [item.id], method: 'delete' }"
                preserveScroll>
                <template #default="{ changeModel }">
                    <Button size="xs" type="delete" icon="far fa-trash-alt" @click="() => changeModel()" />
                </template>
            </ModalConfirmationDelete>
        </template>
    </Table>
</template>
